"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r,
    o = n(e),
    a = function a() {
  return o.createElement(t.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M6.427,8.245A.5.5,0,0,1,6.862,7.5H17.138a.5.5,0,0,1,.435.749l-5.139,9a.5.5,0,0,1-.868,0Z"
  }));
},
    i = function i() {
  return o.createElement(t.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M9.248,17.572a.5.5,0,0,1-.748-.434V6.862a.5.5,0,0,1,.748-.434l8.992,5.138a.5.5,0,0,1,0,.868Z"
  }));
},
    c = function c(e) {
  var t = e.bookmark,
      n = e.depth,
      r = e.doc,
      c = e.index,
      u = e.numberOfSiblings,
      l = e.store,
      m = e.onJumpToDest,
      f = o.useState(!0),
      d = f[0],
      k = f[1],
      p = t.items && t.items.length > 0;
  return o.createElement("li", {
    "aria-expanded": d ? "true" : "false",
    "aria-label": t.title,
    "aria-level": n + 1,
    "aria-posinset": c + 1,
    "aria-setsize": u,
    role: "treeitem",
    tabIndex: -1
  }, o.createElement("div", {
    className: "rpv-bookmark__item",
    style: {
      paddingLeft: 1.25 * n + "rem"
    },
    onClick: function onClick() {
      !p && t.dest && m(t.dest);
    }
  }, p && o.createElement("span", {
    className: "rpv-bookmark__toggle",
    onClick: function onClick() {
      return k(function (e) {
        return !e;
      });
    }
  }, d ? o.createElement(a, null) : o.createElement(i, null)), t.url ? o.createElement("a", {
    className: "rpv-bookmark__title",
    href: t.url,
    rel: "noopener noreferrer nofollow",
    target: t.newWindow ? "_blank" : ""
  }, t.title) : o.createElement("div", {
    className: "rpv-bookmark__title",
    onClick: function onClick() {
      p && t.dest && m(t.dest);
    }
  }, t.title)), p && d && o.createElement(s, {
    bookmarks: t.items,
    depth: n + 1,
    doc: r,
    isRoot: !1,
    store: l,
    onJumpToDest: m
  }));
},
    s = function s(e) {
  var t = e.bookmarks,
      n = e.depth,
      r = void 0 === n ? 0 : n,
      a = e.doc,
      i = e.isRoot,
      s = e.store,
      u = e.onJumpToDest;
  return o.createElement("ul", {
    className: "rpv-bookmark__list",
    role: i ? "tree" : "group",
    tabIndex: -1
  }, t.map(function (e, n) {
    return o.createElement(c, {
      bookmark: e,
      depth: r,
      doc: a,
      index: n,
      key: n,
      numberOfSiblings: t.length,
      store: s,
      onJumpToDest: u
    });
  }));
};

!function (e) {
  e[e.Collapse = 0] = "Collapse", e[e.Expand = 1] = "Expand";
}(r || (r = {}));

var u = function u(e) {
  var n = e.bookmarks,
      a = e.doc,
      i = e.store,
      c = e.onJumpToDest,
      u = o.useRef(),
      l = o.useState(i.get("linkAnnotations") || {}),
      m = l[0],
      f = l[1],
      d = function d(e, t) {
    var n = e.dest;
    n && "string" == typeof n && t[n] && (t[n].querySelectorAll('a[data-annotation-link-dest="' + n + '"]').forEach(function (t) {
      t.setAttribute("aria-label", e.title);
    }), e.items && e.items.length && e.items.forEach(function (e) {
      return d(e, t);
    }));
  },
      k = function k(e) {
    return f(e);
  },
      p = function p(e) {
    var t = u.current;
    if (t && e.target instanceof HTMLElement && t.contains(e.target)) switch (e.key) {
      case "ArrowDown":
        e.preventDefault(), v(function (e, t) {
          return e.indexOf(t) + 1;
        });
        break;

      case "ArrowLeft":
        e.preventDefault(), E(r.Collapse);
        break;

      case "ArrowRight":
        e.preventDefault(), E(r.Expand);
        break;

      case "ArrowUp":
        e.preventDefault, v(function (e, t) {
          return e.indexOf(t) - 1;
        });
        break;

      case "End":
        e.preventDefault(), v(function (e, t) {
          return e.length - 1;
        });
        break;

      case " ":
      case "Enter":
      case "Space":
        e.preventDefault(), b();
        break;

      case "Home":
        e.preventDefault(), v(function (e, t) {
          return 0;
        });
    }
  },
      b = function b() {
    var e = document.activeElement.closest(".rpv-bookmark__item").querySelector(".rpv-bookmark__title");
    e && e.click();
  },
      v = function v(e) {
    var t = u.current,
        n = [].slice.call(t.getElementsByClassName("rpv-bookmark__item"));

    if (0 !== n.length) {
      var r = document.activeElement,
          o = n[Math.min(n.length - 1, Math.max(0, e(n, r)))];
      r.setAttribute("tabindex", "-1"), o.setAttribute("tabindex", "0"), o.focus();
    }
  },
      E = function E(e) {
    var t = u.current;

    if (0 !== [].slice.call(t.getElementsByClassName("rpv-bookmark__item")).length) {
      var n = document.activeElement.closest(".rpv-bookmark__item"),
          o = e === r.Collapse ? "true" : "false";

      if (n && n.parentElement.getAttribute("aria-expanded") === o) {
        var a = n.querySelector(".rpv-bookmark__toggle");
        a && a.click();
      }
    }
  };

  return o.useEffect(function () {
    return document.addEventListener("keydown", p), i.subscribe("linkAnnotations", k), function () {
      document.removeEventListener("keydown", p), i.unsubscribe("linkAnnotations", k);
    };
  }, []), o.useEffect(function () {
    n.forEach(function (e) {
      return d(e, m);
    });
  }, [m]), o.useEffect(function () {
    var e = u.current;

    if (e) {
      var t = [].slice.call(e.getElementsByClassName("rpv-bookmark__item"));
      t.length > 0 && (t[0].focus(), t[0].setAttribute("tabindex", "0"));
    }
  }, []), o.createElement("div", {
    ref: u
  }, o.createElement(s, {
    bookmarks: n,
    depth: 0,
    doc: a,
    isRoot: !0,
    store: i,
    onJumpToDest: function onJumpToDest(e) {
      t.getDestination(a, e).then(function (e) {
        var t = e.pageIndex,
            n = e.bottomOffset,
            r = e.scaleTo;
        c(t + 1, n, r);
      });
    }
  }));
},
    l = function l(e) {
  var n = e.doc,
      r = e.store,
      a = e.onJumpToDest,
      i = o.useContext(t.LocalizationContext),
      c = o.useState({
    isLoaded: !1,
    items: []
  }),
      s = c[0],
      l = c[1];
  return o.useEffect(function () {
    l({
      isLoaded: !1,
      items: []
    }), n.getOutline().then(function (e) {
      l({
        isLoaded: !0,
        items: e || []
      });
    });
  }, [n]), s.isLoaded ? 0 === s.items.length ? o.createElement("div", {
    className: "rpv-bookmark__empty"
  }, i && i.bookmark ? i.bookmark.noBookmark : "There is no bookmark") : o.createElement("div", {
    className: "rpv-bookmark__container"
  }, o.createElement(u, {
    bookmarks: s.items,
    doc: n,
    store: r,
    onJumpToDest: a
  })) : o.createElement(t.Spinner, null);
},
    m = function m(e) {
  var n = e.store,
      r = o.useState(n.get("doc")),
      a = r[0],
      i = r[1],
      c = function c(e) {
    i(e);
  };

  return o.useEffect(function () {
    return n.subscribe("doc", c), function () {
      n.unsubscribe("doc", c);
    };
  }, []), a ? o.createElement(l, {
    doc: a,
    store: n,
    onJumpToDest: function onJumpToDest(e, t, r) {
      var o = n.get("jumpToDestination");
      o && o(e, t, 0, r);
    }
  }) : o.createElement("div", {
    className: "rpv-bookmark__loader"
  }, o.createElement(t.Spinner, null));
};

exports.DownArrowIcon = a, exports.RightArrowIcon = i, exports.bookmarkPlugin = function () {
  var e = o.useMemo(function () {
    return t.createStore({
      linkAnnotations: {}
    });
  }, []);
  return {
    install: function install(t) {
      e.update("jumpToDestination", t.jumpToDestination);
    },
    onDocumentLoad: function onDocumentLoad(t) {
      e.update("doc", t.doc);
    },
    Bookmarks: function Bookmarks() {
      return o.createElement(m, {
        store: e
      });
    },
    onAnnotationLayerRender: function onAnnotationLayerRender(t) {
      if (t.annotations.length) {
        var n = t.annotations.filter(function (e) {
          return "Link" === e.subtype;
        });

        if (n.length) {
          var r = e.get("linkAnnotations") || {};
          n.forEach(function (e) {
            return r[e.dest] = t.container;
          }), e.update("linkAnnotations", r);
        }
      }
    }
  };
};